import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_INFO } from '../data';
import ContactForm from '../components/ContactForm';

export default function ContactPage() {
  return (
    <div className="py-12 bg-slate-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Breadcrumbs */}
        <nav className="flex mb-8 text-xs text-slate-500" aria-label="Breadcrumb">
          <ol className="inline-flex items-center space-x-1 md:space-x-3">
            <li className="inline-flex items-center">
              <Link to="/" className="hover:text-primary transition-colors flex items-center gap-1.5">
                <i className="fa-solid fa-house text-[10px]" />
                <span>Forside</span>
              </Link>
            </li>
            <li>
              <div className="flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[8px] text-slate-400" />
                <span className="font-medium text-slate-700">Kontakt</span>
              </div>
            </li>
          </ol>
        </nav>

        <div className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-12">
            {/* Contact Info Column */}
            <div className="lg:col-span-5 bg-secondary text-white p-8 lg:p-12 flex flex-col justify-between relative overflow-hidden">
              {/* Background Image with Overlay */}
              <div className="absolute inset-0 z-0">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c39928d5-b2a6-4904-83a9-11ba7b5b852e/kontakt.jpg"
                  alt="Vester-Bo Kontakt"
                  className="w-full h-full object-cover opacity-15"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-secondary/95 via-secondary to-secondary" />
              </div>

              <div className="relative z-10 space-y-8">
                <div>
                  <span className="text-xs font-bold uppercase tracking-widest text-teal-300">Kontakt os</span>
                  <h1 className="font-serif text-3xl sm:text-4xl font-bold mt-2">Vi står altid klar til at hjælpe</h1>
                </div>

                <p className="text-slate-300 text-sm leading-relaxed">
                  Uanset om du er sagsbehandler, pårørende eller kommende beboer, er du altid velkommen til at kontakte os for en uforpligtende snak eller for at aftale et forbesøg.
                </p>

                <div className="space-y-6 pt-4">
                  {/* Address */}
                  <div className="flex items-start gap-4">
                    <div className="h-10 w-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
                      <i className="fa-light fa-location-dot text-primary text-lg" />
                    </div>
                    <div>
                      <h4 className="font-serif font-bold text-white text-sm">Adresse</h4>
                      <p className="text-xs text-slate-300 mt-1">{CONTACT_INFO.address}</p>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="flex items-start gap-4">
                    <div className="h-10 w-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
                      <i className="fa-light fa-phone text-primary text-lg" />
                    </div>
                    <div>
                      <h4 className="font-serif font-bold text-white text-sm">Telefon (Hovednummer)</h4>
                      <p className="text-xs text-slate-300 mt-1">
                        <a href={`tel:${CONTACT_INFO.phone}`} className="hover:text-primary transition-colors">{CONTACT_INFO.phone}</a>
                      </p>
                    </div>
                  </div>

                  {/* Direct Contacts */}
                  <div className="flex items-start gap-4">
                    <div className="h-10 w-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
                      <i className="fa-light fa-users text-primary text-lg" />
                    </div>
                    <div>
                      <h4 className="font-serif font-bold text-white text-sm">Direkte nummer til ledelsen</h4>
                      <p className="text-xs text-slate-300 mt-1.5 flex flex-col gap-1">
                        <span>Marianne Lind: <a href={`tel:${CONTACT_INFO.mariannePhone}`} className="hover:text-primary transition-colors font-semibold text-white">{CONTACT_INFO.mariannePhone}</a></span>
                      </p>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="flex items-start gap-4">
                    <div className="h-10 w-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
                      <i className="fa-light fa-envelope text-primary text-lg" />
                    </div>
                    <div>
                      <h4 className="font-serif font-bold text-white text-sm">E-mail</h4>
                      <p className="text-xs text-slate-300 mt-1">
                        <a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-primary transition-colors">{CONTACT_INFO.email}</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="relative z-10 pt-12 border-t border-white/10 mt-12">
                <div className="flex items-center gap-4">
                  <img
                    src="https://assets.auxodev.dk/assets/c39928d5-b2a6-4904-83a9-11ba7b5b852e/botlog.png"
                    alt="Vester-Bo Bundlogo"
                    className="h-10 w-auto object-contain brightness-0 invert opacity-80"
                  />
                  <div className="text-[10px] text-slate-400 uppercase tracking-wider">
                    Social-psykiatrisk opholdssted
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form Column */}
            <div className="lg:col-span-7 p-8 lg:p-12 bg-white">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
